/**
 * @author xiaohuangmaoth
 * @description 在线课程组织完成率
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

class OrgCourseLearningStatistics extends WizContainer {
  componentName = "OrgCourseLearningStatistics";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res
    const title = '在线课程组织完成率'

    if (success) {
      const rows = data.map(val => ({
        ...val,
        rate: val.rate + '%',
        passRate: val.passRate + '%',
      }))

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true
      
    } else {
      wizNotice.error(msg)
      return false;
    }
  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(OrgCourseLearningStatistics);
